v-container
  v-row
    v-col(cols="12")
      v-form(ref="formRef" v-model="valid" @submit.prevent="onSubmit")
        v-card
          v-card-text
            //- Title
            v-row
              v-col(cols="12")
                h2.text-h4.mb-4(v-html="$t('title')")

            v-divider.my-4

            //- Blood Thinners Section
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('question1.heading')")
                p.text-body-1.mb-3(v-html="$t('question1.text1')")
            v-divider.my-4

            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('question2.heading')")
                p.text-body-1.mb-3(v-html="$t('question2.text1')")
                p.text-body-1.mb-3(v-html="$t('question2.text2')")
                p.text-body-1.mb-3(v-html="$t('question2.text3')")
                p.text-body-1.mb-3(v-html="$t('question2.text4')")

            v-divider.my-4

            //- Patient's Acceptance of Risks
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('acceptance.heading')")
                p.text-body-1.mb-3(v-html="$t('acceptance.text')")

            v-divider.my-6

            //- Signature Section
            v-row
              v-col(cols="12")
                NameDateSignature(
                  v-model:name="form.name"
                  v-model:date="form.date"
                  v-model:signature="form.signature"
                  :name_rules="[form.validCheck('name')]"
                  :date_rules="[form.validCheck('date')]"
                  :signature_rules="[form.validCheck('signature')]"
                )

          v-card-actions.d-flex.justify-end
            if error
              .error.text-red-lighten-1 {{ error }}
            v-btn(color="primary" type="submit" :loading="loading") {{ $t('common.submit') }}
